let initialState = {
	purchases: [],
};

const purchaseReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'LOGOUT': {
			return initialState;
		}

		case 'GET_PURCHASE':
			return {
				...state,
				purchases: action.payload,
			};
		default:
			return state;
	}
};

export { purchaseReducer };
